export { type CardHorizontalFeatureProps, type CTAType } from './CardHorizontalFeature.types';
export { CardHorizontalFeature } from './CardHorizontalFeature';
